import { convertMarkdownToHtml, displayDate } from "~/plugins/functions/display";
import type { IModelConversationSource, IModelPOSTConversationAssociationConversationFileRespone} from "./conversation.detail.dto";
import { ModelSource, ModelPOSTConversationAssociationConversationFile } from "./conversation.detail.dto";
export interface IModelConversationRespone {
  id: string;
  presetId: number;
  userId: number;
  name: string;
  createdAt: string | Date;
  updatedAt: string | Date;
}

export class ModelConversation {
  id: string;
  presetId: number;
  userId: number;
  name: string;
  createdAt: string | Date;
  updatedAt: string | Date;
  icon: string;
  iconDefault: string;
  isActive: boolean;

  constructor(props = {} as IModelConversationRespone) {
    this.id = props.id;
    this.presetId = props.presetId;
    this.userId = props.userId;
    this.name = props.name || '';
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;

    this.icon = '/images/icons/ic-chat-bubble-left-right-area-fill.svg';
    this.iconDefault = '/images/icons/ic-chat-bubble-left-right-area-outline-white.svg';
    this.isActive = false;
  }
}

export interface IModelThumb {
  id: string;
  type: 'up' | 'down';
  comment?: string;
}

export class ModelThumb {
  id: string;
  type: 'up' | 'down';
  comment?: string;

  constructor(props = {} as IModelThumb) {
    this.id = props.id;
    this.type = props.type;
    this.comment = props.comment || '';
  }
}

export interface IModelThumbFeedbackResponse {
  id: string;
  status: 'completed' | 'pending' | 'failed';
  files: string[];
  thumbs: 'up' | 'down';
  conversationId: string;
  parentId: string | null;
  branchId: number;
  versionPosition: number;
  versionTotal: number;
  humanMessage: string;
  aiMessage: string;
  inputToken: string;
  outputToken: string;
  toolSearchWeb: boolean;
  isMaxToken: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
  softDeleted: boolean;
  thumbsDownComment?: string;
}

export class ModelThumbFeedbackResponse {
  id: string;
  status: 'completed' | 'pending' | 'failed';
  files: string[];
  thumbs: 'up' | 'down';
  conversationId: string;
  parentId: string | null;
  branchId: number;
  versionPosition: number;
  versionTotal: number;
  humanMessage: string;
  aiMessage: string;
  inputToken: string;
  outputToken: string;
  toolSearchWeb: boolean;
  isMaxToken: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
  softDeleted: boolean;
  thumbsDownComment?: string;

  constructor(props = {} as IModelThumbFeedbackResponse) {
    this.id = props.id;
    this.status = props.status;
    this.files = props.files || [];
    this.thumbs = props.thumbs;
    this.conversationId = props.conversationId;
    this.parentId = props.parentId;
    this.branchId = props.branchId;
    this.versionPosition = props.versionPosition;
    this.versionTotal = props.versionTotal;
    this.humanMessage = props.humanMessage || '';
    this.aiMessage = props.aiMessage || '';
    this.inputToken = props.inputToken;
    this.outputToken = props.outputToken;
    this.toolSearchWeb = props.toolSearchWeb;
    this.isMaxToken = props.isMaxToken;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
    this.softDeleted = props.softDeleted;
    this.thumbsDownComment = props.thumbsDownComment || '';
  }
}
export interface IModelSharedConversationMessageDetail {
  id: string;
  conversationId: string;
  parentId: string | null;
  branchId: number;
  versionPosition: number;
  versionTotal: number;
  status: 'completed' | 'pending' | 'failed';
  humanMessage: string;
  aiMessage: string;
  files: IModelPOSTConversationAssociationConversationFileRespone[];
  inputToken: string;
  outputToken: string;
  toolSearchWeb: boolean;
  isMaxToken: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
  softDeleted: boolean;
  thumbs: 'up' | 'down' | null;
  thumbsDownComment?: string | null;
  model?: string | null;
  sources: IModelConversationSource[];
  conversation: any;
  genImage: any[]

}

export class ModelSharedConversationMessageDetail {
  id: string;
  conversationId: string;
  parentId: string | null;
  branchId: number;
  versionPosition: number;
  versionTotal: number;
  status: 'completed' | 'pending' | 'failed';
  humanMessage: string;
  aiMessage: string;
  inputToken: string;
  outputToken: string;
  toolSearchWeb: boolean;
  isMaxToken: boolean;
  createdAt: string | Date;
  updatedAt: string | Date;
  softDeleted: boolean;
  thumbs: 'up' | 'down' | null;
  thumbsDownComment?: string | null;
  model?: string | null;
  sources: any[];
  conversation: any;

  filesList: ModelPOSTConversationAssociationConversationFile[];
  sourceList: ModelSource[];
  generatedImagesList: ModelPOSTConversationAssociationConversationFile[];
  displayCreatedAt: string;
  displayUpdatedAt: string;

  constructor(props = {} as IModelSharedConversationMessageDetail) {
    this.id = props.id;
    this.conversationId = props.conversationId;
    this.parentId = props.parentId ?? null;
    this.branchId = props.branchId;
    this.versionPosition = props.versionPosition;
    this.versionTotal = props.versionTotal;
    this.status = props.status;
    this.humanMessage = props.humanMessage || '';
    this.aiMessage =  convertMarkdownToHtml(props.aiMessage || '', { isEndStream: true });
    this.inputToken = props.inputToken;
    this.outputToken = props.outputToken;
    this.toolSearchWeb = props.toolSearchWeb;
    this.isMaxToken = props.isMaxToken;
    this.createdAt = props.createdAt;
    this.updatedAt = props.updatedAt;
    this.softDeleted = props.softDeleted;
    this.thumbs = props.thumbs ?? null;
    this.thumbsDownComment = props.thumbsDownComment ?? null;
    this.model = props.model ?? null;
    this.sources = props.sources || [];
    this.conversation = props.conversation;

    this.filesList = (props.files || []).map(e => new ModelPOSTConversationAssociationConversationFile(e));
    this.sourceList = (props.sources || []).map(e => new ModelSource(e));
    this.generatedImagesList = (props.genImage || []).map(e => new ModelPOSTConversationAssociationConversationFile(e));
    this.displayCreatedAt = displayDate(this.createdAt, {
      isTimeOnly: true
    });
    this.displayUpdatedAt = displayDate(this.updatedAt, {
      isTimeOnly: true
    });
  }
}